import { WebStorageStateStore } from "oidc-client-ts";
import { ENVIRONMENTS, getDeployedHost, HOSTS } from "rylak-common";

/** @returns {import("oidc-client-ts").OidcClientSettings} **/
export function getOidcConfig(selectedHostName, localhostEnv) {
    if (typeof window === "undefined") {
        return null;
    }

    const redirect_uri = `${window.location.protocol}//${window.location.host}/newlogin`;
    const userStore = new WebStorageStateStore({ store: window.localStorage });

    function buildConfig(envKey, useLocalhostClientId = false) {
        const { authority, clientId, clientIdLocalhost } = HOSTS[envKey].oidcAuth;
        return {
            authority,
            metadataUrl: `${authority}/.well-known/openid-configuration`,
            client_id: useLocalhostClientId && clientIdLocalhost ? clientIdLocalhost : clientId,
            redirect_uri,
            post_logout_redirect_uri: redirect_uri,
            scope: "openid email offline_access",
            userStore,
        };
    }

    if (selectedHostName === ENVIRONMENTS.LOCALHOST) {
        const envKey = ENVIRONMENTS[localhostEnv] || ENVIRONMENTS.DEV;
        return buildConfig(envKey, true);
    }
    if (selectedHostName) {
        return buildConfig(ENVIRONMENTS[selectedHostName] || ENVIRONMENTS.DEV, true);
    }
    // No stored host (deployed environment): fall back to URL-based detection
    return buildConfig(getDeployedHost().key);
}
